import React from 'react';
import classNames from '../../../../utils/classnameUtils';
import './styles.scss';

function EPGTimeList({
  arrayFromTime,
  swiperSlideLength,
  slidesPerView,
  firstSwiper,
  turnOffLive,
}) {
  return (
    <div className="epgGridList_swiper_containerTime">
      {arrayFromTime?.map((t, index) => (
        <div
          className={classNames(
            'epgGridList_swiper_time_container',
            'epgGridList_swiper_time_container_index_' + index,
          )}
          style={{ width: 100 / (swiperSlideLength / slidesPerView) + '%' }}
          key={'epgGridList_swiper_containerTime-' + t.formattedTime}
        >
          <a
            className={'epgGridList_swiper_time'}
            onClick={() => {
              turnOffLive();
              firstSwiper?.slideTo(index, 500);
            }}
          >
            {t.formattedTime}
          </a>
        </div>
      ))}
    </div>
  );
}

export default React.memo(EPGTimeList);
